import { Injectable } from '@angular/core';
import { Table } from '@table/classes/table.class';
import { CountColumn, NameColumn } from '@documents-v2/services/tables/manage-tags-index/columns';
import { DocumentTag } from '@models/documents/document-tag.model';
import { Paginator, SortDirection } from '@app/classes';
import { AuthService } from '@app/services';
import { MenuColumnItem } from '@table/interfaces/menu-column-item.interface';

const renameOption: MenuColumnItem = {
    label: 'document.rename',
    event: 'rename',
};

const deleteOption: MenuColumnItem = {
    label: 'document.delete',
    event: 'delete',
};

@Injectable()
export class ManageTagsIndexTable extends Table {
    showMenuColumnOptions = true;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        const nameColumn = new NameColumn();
        const countColumn = new CountColumn();
        const columns = [nameColumn, countColumn];
        this.sortColumn = nameColumn;
        this.sortDirection = SortDirection.ASC;
        this.columns = columns;
    }

    setDataSource(): void {
        this.paginator = new Paginator(DocumentTag.query());
    }

    getMenuColumnOptionsForRow(tag: DocumentTag): MenuColumnItem[] {
        return [renameOption, deleteOption];
    }
}
